/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Blankoaccount1Inputs */

const de__field_blankoaccount1 = /** @type {(inputs: _Field_Blankoaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blanko-Account`)
};

/**

* @param {_Field_Blankoaccount1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_blankoaccount1 = /** @type {((inputs?: _Field_Blankoaccount1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Blankoaccount1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_blankoaccount1(inputs)
});
export { _field_blankoaccount1 as "_field_blankoAccount" }